import { styled } from '@mui/styles'
import { Box } from '@mui/material'

export const RightControls = styled(Box)(({ theme }) => ({
  position: 'absolute',
  zIndex: 1,
  right: 16,
  bottom: 24,
  width: 40,
  height: 'auto',
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'flex-end',
  gap: 16,
  flexGrow: 0,
  flexDirection: 'column',
}))

export const LeftControls = styled(Box)(({ theme }) => ({
  position: 'absolute',
  zIndex: 1,
  left: 0,
  bottom: 26,
  width: 0,
  height: 40,
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'flex-start',
  gap: 16,
  flexGrow: 0,
  flexDirection: 'column',
}))